import Highcharts from 'highcharts'
import annotations from 'highcharts/modules/annotations'
import heatmap from 'highcharts/modules/heatmap'
import patternFill from 'highcharts/modules/pattern-fill'

import borderRadius from './highcharts-border-radius'
import { reflowChartsWidth } from './utils'

import './style.css'

annotations(Highcharts)
borderRadius(Highcharts)
heatmap(Highcharts)
patternFill(Highcharts)

Highcharts.setOptions({
  colors: [
    'var(--color-p3-7)',
    'var(--color-s5-5)',
    'var(--color-s4-6)',
    '#da3490', // ¯\_(ツ)_/¯
    'var(--color-s1-7)',
    'var(--color-p2-6)',
  ],
  chart: {
    animation: false,
    style: {
      fontFamily: 'ProximaNova-Regular',
    },
    height: 338,
  },

  title: {
    text: '',
  },

  credits: {
    enabled: false,
  },
})

window.addEventListener('resize', reflowChartsWidth)
